import { graphql, Link } from "gatsby"
import React from "react"
import Layout from "../../components/Layout"
import * as styles from "../../styles/projects.module.css"
import Img from "gatsby-image"

export default function ProjectPage({ data }) {
  // console.log(data)
  const projects = data.projects.nodes
  const contact = data.contact.siteMetadata.contact
  return (
    <Layout>
      <div className={styles.portfolio}>
        <h2>Portfolio</h2>
        <h3>Projects & Websites I have created</h3>
        <div className={styles.projects}>
          {projects.map(v => (
            <Link to={`/projects/${v.frontmatter.slug}`} key={projects.id}>
              <div>
                <Img fluid={v.frontmatter.thumb.childImageSharp.fluid} />
                <h3>{v.frontmatter.title}</h3>
                <p>{v.frontmatter.stack}</p>
              </div>
            </Link>
          ))}
        </div>
        <p>
          Email me at this address{" "}
          <strong>
            <a href="mailto:hamz.4you@gmail.com" rel="noopener">
              {contact}
            </a>
          </strong>{" "}
          for any query
        </p>
      </div>
    </Layout>
  )
}

// export page query

export const query = graphql`
  query ProjectsPage {
    projects: allMarkdownRemark {
      nodes {
        frontmatter {
          slug
          stack
          title
          thumb {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        id
      }
    }
    contact: site {
      siteMetadata {
        contact
      }
    }
  }
`
